/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import IFrameSetupFrom from "./IFrameSetup/IFrameSetupFrom"

export const IFramesetup = (props) => {

    return (
        <>
            <div className="row align-content-start position-relative" style={{minHeight: "76vh"}}>
                <div className="col-12">  
                    <IFrameSetupFrom userinfo={props.userinfo} language={props.language}/>
                </div>
            </div>
        </>
    );
};
